<template>
    <div class="col-12 px-0 pt-1">
        <template v-if="hasTag">
            <div class="form-row">
                <div class="form-group col-md-6" :class="markInputRequired ? 'required' : ''">
                    <label :for="`input_tag_address_${_uid}`" class="col-form-label">Tag</label>
                    <input :id="`input_tag_address_${_uid}`" v-model="form.tag" type="text" list="tags" class="form-control"/>
                    <datalist id="tags">
                        <option v-for="tag in tags" :key="tag" v-text="tag"></option>
                    </datalist>
                </div>
            </div>
        </template>

        <template v-if="hasPeopleContact">
            <div class="col-12 px-0">
                <div class="form-row mb-3">
                    <div class="form-group col-12 col-md-6" :class="markInputRequired ? 'required' : ''">
                        <label :for="`people_contact_modal_${_uid}`" class="col-form-label">Pessoa para contato</label>
                        <input :id="`people_contact_modal_${_uid}`" v-model="form.people_contact" type="text" class="form-control" placeholder="Indique um nome"/>
                    </div>
                    <div class="form-group col-12 col-md-6 required">
                        <label :for="`phone_modal_${_uid}`" class="col-form-label">Telefone</label>
                        <input :id="`phone_modal_${_uid}`" v-model="form.phone" type="text" placeholder="(11) 00000-0000" class="form-control" v-mask="'(##) #-####-####'"/>
                    </div>
                </div>
            </div>
        </template>
        <!-- Address -->
        <div class="form-inline mb-2">
            <div class="form-group">
                <label :for="`inputZip_${_uid}`" class="mr-1">Encontrar endereço pelo CEP:</label>
                <input :id="`inputZip_${_uid}`" v-model="zip_code" v-mask="'#####-###'" type="text" placeholder="Ex: 01001-000" class="form-control mr-1"/>
            </div>
            <button v-if="!btnLoading" type="submit" class="btn btn-info" @click="getCep(zip_code)">Procurar</button>
            <button class="btn btn-info ml-1" type="button" disabled v-else>
                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Procurando...
            </button>
        </div>
        <div class="form-row">
            <div class="form-group col-12 col-md-8" :class="markInputRequired ? 'required' : ''">
                <label :for="`input_address_${_uid}`" class="col-form-label">Logradouro</label>
                <input :id="`input_address_${_uid}`" v-model="form.street" type="text" placeholder="Av. Paulista" class="form-control"/>
            </div>
            <div class="form-group col-12 col-md-4" :class="markInputRequired ? 'required' : ''">
                <label :for="`number_address_${_uid}`" class="col-form-label">Número</label>
                <input :id="`number_address_${_uid}`" v-model="form.number" type="text" placeholder="7" class="form-control"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12 col-md-3" :class="markInputRequired ? 'required' : ''">
                <label :for="`zip_code_${_uid}`" class="col-form-label">CEP</label>
                <input :id="`zip_code_${_uid}`" v-model="form.zip_code" type="text" placeholder="01210-210" class="form-control"/>
            </div>
            <div class="form-group col-12 col-md-3">
                <label :for="`input_complement_${_uid}`" class="col-form-label">Complemento</label>
                <input :id="`input_complement_${_uid}`" v-model="form.complement" type="text" placeholder="Apartment, studio, or floor" class="form-control"/>
            </div>

            <div class="form-group col-md-6" :class="markInputRequired ? 'required' : ''">
                <label class="col-form-label">Estado</label>
                <multi-select v-model="stateSelected" deselect-label="Deve selecionar um estado" track-by="sigla" label="nome"
                              placeholder="Selecione o Estado" :options="states" :allow-empty="false" >
                </multi-select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-6" :class="markInputRequired ? 'required' : ''">
                <label class="col-form-label">Cidade</label>
                <multi-select v-model="citySelected" deselect-label="Can't remove this value" track-by="nome" label="nome"
                              placeholder="Selecione a Cidade" :options="cities" :allow-empty="false">
                </multi-select>
            </div>

            <div class="form-group col-md-6" :class="markInputRequired ? 'required' : ''">
                <label :for="`input_neighborhood${_uid}`" class="col-form-label">Bairro</label>
                <input :id="`input_neighborhood${_uid}`" v-model="form.neighborhood" type="text" list="neighborhood" class="form-control"/>
                <datalist id="neighborhood">
                    <option v-for="neighborhood in neighborhoods" :key="neighborhood.id">
                        {{ neighborhood.nome }}
                    </option>
                </datalist>
            </div>
        </div>
    </div>
</template>

<script>
import { isUndefinedOrNull, isObject, isArray } from 'tupy-helperjs'
export default {
    name: "FormAddress",
    data(){
        const _this = this;
        return {
            btnLoading: false,
            states: [],
            stateSelected: null,
            cities: [],
            citySelected: null,
            neighborhoods: [],
            zip_code: undefined,
            // form: {...this.value},
            people: window.userAuth.name,
            errors: [],
            tags: ['Casa', 'Trabalho'],
            _uid: _this._uid,
        }
    },

    model: {
        prop: 'value',
        event: 'input',
    },

    props: {
        value: {
            required: true,
        },
        hasPeopleContact: {
            type: Boolean,
            default: true,
        },
        hasTag: {
            type: Boolean,
            default: true,
        },
        markInputRequired: {
            type: Boolean,
            default: true,
        }
    },

    // watch: {
        // form: {
        //     deep: true,
        //     handler(value) {
        //         this.$emit('input', value);
        //     }
        // }
    // },

    created(){
        // this.form = this.defaultAddress()
        this.getStates();
        this.setInitialData()

        // if (this.form.city) {
        //     this.citySelected = {nome: this.form.city}
        // }

        // if (this.form.state) {
        //     this.stateSelected = this.states.find((obj) => obj.nome === this.form.state)
        //     //this.getCitiesByState(this.stateSelected)
        // }
    },
    mounted() {
      if (this.form.state) {
        this.stateSelected = this.states.find((obj) => obj.sigla === this.form.state);
        // this.getCitiesByState(this.stateSelected);
      }
      // axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.form.state}/distritos`).then((response) => {
      //   console.log(response.data);
      // });
    },

    computed: {
          form: {
              get(){
                  return this.value
              },

              set(value){
                  this.$emit('input', value)
              }
          }
      },
    watch: {
        stateSelected(value){
            if (value) {
                this.form.state = value.sigla
                this.getCitiesByState(value)
            }
        },

        citySelected(value){
            if (value) {
                this.form.city = value.nome
                // this.getNeighborhoodByCity(value)
            }
        }
    },
    methods: {
        getCep(cep) {
            this.errors = []
            this.setLoading()

            if (!cep) {
                alert('Favor, indique um cep')
                this.btnLoading = false
                this.defaultAddress()
                return false
            }

            this.$helpers.sleep(1000).then(() => {
                // Nova variável "cep" somente com dígitos.
                const newCep = cep.replace(/\D/g, '')

                // Expressão regular para validar o CEP.
                const validateZipCode = /^[0-9]{8}$/
                if (validateZipCode.test(newCep)) {
                    this.$viaCep.searchCep(newCep).then(({data}) => {
                        const { cep, localidade, bairro, complemento, ibge, uf, logradouro, unidade, gia } = data

                        const address = {
                            zip_code: cep,
                            street: logradouro,
                            number: null,
                            complement: complemento,
                            neighborhood: bairro,
                            city: localidade,
                            uf: uf,
                            state: uf,
                            country: 'Brasil',
                            unidade,
                            ibge,
                            gia
                        }
                        this.citySelected = { nome: localidade }
                        this.form = { ...this.form, ...address }
                        this.stateSelected = this.states.find((obj) => obj.sigla === address.uf);
                        this.getCitiesByState(this.stateSelected)
                    }).catch(() => {
                        this.form = this.defaultAddress()
                        this.btnLoading = false
                        this.errors.push('CEP não encontrado.')
                        this.$emit('error', this.errors)
                    }).finally(() => {
                        this.btnLoading = false
                    })
                } else {
                    this.errors.push('Formato de CEP inválido.')
                    this.$emit('error', this.errors)
                }
            })
        },
        getStates() {
            if (this.$ls.get('states')) {
                let states = this.$ls.get('states');

                //Estou adicionando essa verificação porque quando da erro na api, no localstorage grava undefined
                //Caso estiver com erro, limpo os dados
                if (isUndefinedOrNull(states) || states === 'undefined') {
                    this.$ls.remove('states');
                    this.states = [];
                } else {
                    this.states = JSON.parse(states)
                }
            } else {
                this.$ibge.states().then((data) => {
                  if (isArray(data)) {
                      this.states = data
                      this.$ls.set('states', JSON.stringify(data))
                    }
                })
            }
        },
        getCitiesByState(option) {
          if (isObject(option) && option.hasOwnProperty('nome')) {
            this.form.state = option.sigla;
                this.$ibge.cities(option.id).then((data) => {
                    this.cities = data
                })
            }
        },
        //I THINK THIS IS NOT BEING USED
        // getNeighborhoodByCity(option) {
        //     if (isObject(option) && option.hasOwnProperty('nome')) {
        //         this.form.city = option.nome
        //         this.$ibge.neighborhoods(option.id).then(({data}) => {
        //             this.neighborhoods = data
        //         })
        //     }
        // },
        defaultAddress() {
            this.stateSelected = null
            this.citySelected = null
            return {
                zip_code: null,
                street: null,
                number: null,
                complement: null,
                neighborhood: null,
                city: null,
                uf: null,
                state: null,
                country: null,
                unidade: null,
                ibge: null,
                gia: null,
                people_contact: this.people,
                phone: null,
                firstRender: true,
            }
        },
        setLoading(){
            this.btnLoading = true
            this.form.street = '...'
            this.form.complement = '...'
            this.form.neighborhood = '...'
            this.form.city = '...'
            this.form.zip_code = '...'
            this.stateSelected = { sigla: '...', nome: '...' }
            this.citySelected = { nome: '...' }
        },
        setInitialData(){
            if (this.form.hasOwnProperty('state')) {
                this.stateSelected = this.states.find((obj) => obj.nome === this.form.state);
                this.getCitiesByState(this.stateSelected);
            }

            if (this.value.hasOwnProperty('city')) {
                this.citySelected = {nome: this.form.city};
                // this.getNeighborhoodByCity(this.citySelected)
            }
        }
    }
}
</script>

<style scoped>

</style>
